import { api } from '@shared/api/api';

type ParkingRequestData = App.Domain.Parking.Data.ParkingRequestData;

export function getParkingRequest(registrationId: number, parkingRequestId: number) {
  return api.get<ParkingRequestData>(`registrations/${registrationId}/parking-requests/${parkingRequestId}`);
}
